import React from 'react'
import styled from 'styled-components'

const TranslateContainer = styled.div`
  bottom: 0;
  right: 0;
  position: absolute;
  margin: 1em;

  @media (max-width: 900px) {
    position: relative;
    text-align: center;
  }
`

const Translate = () => (
  <TranslateContainer>
    <div id="google_translate_element" />
  </TranslateContainer>
) 

export default Translate
